import * as React from 'react';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';

/**
 * iOS keeps the WKWebView a fixed size when the keyboard appears (Keyboard.resize: 'none'
 * in capacitor.config.ts), so fixed/overlaid content never reflows on its own — track the
 * keyboard height here so callers can reserve space for it instead of being overlaid.
 */
export function useIosKeyboardHeight() {
  const [height, setHeight] = React.useState(0);

  React.useEffect(() => {
    if (Capacitor.getPlatform() !== 'ios') return;

    const willShow = Keyboard.addListener('keyboardWillShow', info => setHeight(info.keyboardHeight));
    const willHide = Keyboard.addListener('keyboardWillHide', () => setHeight(0));

    return () => {
      willShow.then(handle => handle.remove());
      willHide.then(handle => handle.remove());
    };
  }, []);

  return height;
}
